module.exports = __webpack_public_path__ + "img/card_nevi_ElecrtrifyAmerica_3.e87d9b6e.png";